import { render, staticRenderFns } from "./CakeDetail.vue?vue&type=template&id=8ebf06a4&scoped=true&"
import script from "./CakeDetail.vue?vue&type=script&lang=js&"
export * from "./CakeDetail.vue?vue&type=script&lang=js&"
import style0 from "./CakeDetail.vue?vue&type=style&index=0&id=8ebf06a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebf06a4",
  null
  
)

export default component.exports